export enum EntityTypes {
  AD_PRICE_UPDATE = 'AD_PRICE_UPDATE',
  AD_SPEC_UPDATE = 'AD_SPEC_UPDATE',
  AD_PLACEMENT_UPDATE = 'AD_PLACEMENT_UPDATE',
  AD_TYPE_UPDATE = 'AD_TYPE_UPDATE',
  AD_MEDIUM_UPDATE = 'AD_MEDIUM_UPDATE',
}

export enum ProductTypes {
  DIGITAL = 'DIGITAL',
  PRINT = 'PRINT',
  RADIO = 'RADIO',
  TV = 'TV',
  POS = 'POS',
  CONSULTING = 'CONSULTING',
}
